module.exports = __webpack_public_path__ + "static/media/toggle_up.73873db3.svg";